/**
 * Get error message from API response or error object
 * Handles specific error codes and returns appropriate error messages
 */
export const getApiErrorMessage = (errorData: any, defaultMessage: string = 'An error occurred'): string => {
    // Extract error code from various possible locations
    const errorCode = errorData?.output?.code ||
        errorData?.responseBody?.output?.code ||
        errorData?.response?.data?.output?.code;

    // Extract API message
    const apiMessage = errorData?.apiMessage ||
        errorData?.responseBody?.apiMessage ||
        errorData?.response?.data?.apiMessage;

    // Check for specific error codes
    if (errorCode === 'TALENT_POOL_ALREADY_IN_PROGRESS') {
        return 'Talent pool processing is already in progress for this job. Please wait for the current request to complete.';
    }

    // Return API message or default
    return apiMessage || defaultMessage;
};
